export const API_STATUS_CODE = {SUCCESS: 200};
export const STORAGE_KEY_PREFIX = process.env.VUE_APP_NAME;
export const APP_SITE = process.env.VUE_APP_SITE;
export const APP_VERSION = process.env.VUE_APP_VERSION;